module.exports = __webpack_public_path__ + "img/logo-epic.fe7fda30.svg";